var DEFAULT_STRINGS = {
    warningHeader: 'Do you want to continue your session?',
    warningBody: 'For security reasons, your session will time out unless you choose to continue.',
    warningButton: 'Continue',
    sessionHeader: 'Your session has timed out.',
    sessionBody: 'Due to security reasons, your session has timed out.',
    sessionButton: 'OK'
};
export default DEFAULT_STRINGS;
